import { render, staticRenderFns } from "./hotManage.vue?vue&type=template&id=6457dc45&scoped=true&"
import script from "./hotManage.vue?vue&type=script&lang=ts&"
export * from "./hotManage.vue?vue&type=script&lang=ts&"
import style0 from "./hotManage.vue?vue&type=style&index=0&id=6457dc45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6457dc45",
  null
  
)

export default component.exports